import React, { useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../components/tables/ReportsTable';

const serviceTypes = [
  'AEPS',
  'Recharge',
  'Bill Payment',
  'BBPS',
  'DMT',
  'Payout',
  'Micro ATM'
];

const txnStatuses = ['Successful', 'Pending', 'Failed', 'Reversed'];

const generateDistributorTxnData = (count = 140) => {
  return Array.from({ length: count }, (_, index) => {
    const txnDate = new Date(
      2025,
      Math.floor(Math.random() * 12),
      Math.floor(Math.random() * 28) + 1,
      Math.floor(Math.random() * 24),
      Math.floor(Math.random() * 60)
    );

    const amount = parseFloat((Math.random() * 95000 + 2500).toFixed(2));
    const charge = parseFloat((amount * 0.0045).toFixed(2));
    const commission = parseFloat((amount * 0.015).toFixed(2));

    return {
      txnId: `SDTXN${String(index + 1).padStart(6, '0')}`,
      date: txnDate.toISOString().split('T')[0],
      time: txnDate.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }),
      masterDistributorCode: `MD${String(Math.floor(Math.random() * 9000) + 1000)}`,
      masterDistributorName: `Master Distributor ${Math.floor(Math.random() * 60) + 1}`,
      distributorCode: `DIS${String(Math.floor(Math.random() * 9000) + 1000)}`,
      distributorName: `Distributor ${Math.floor(Math.random() * 220) + 1}`,
      service: serviceTypes[Math.floor(Math.random() * serviceTypes.length)],
      amount,
      charge,
      commission,
      status: txnStatuses[Math.floor(Math.random() * txnStatuses.length)],
      rrn: Math.random().toString(36).substring(2, 10).toUpperCase(),
      referenceId: `REF${Math.random().toString(36).substring(2, 10).toUpperCase()}`
    };
  });
};

const formatCurrency = (value) =>
  `₹${Number(value || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

const ReportsDistributorTransactions = () => {
  const [transactions] = useState(() => generateDistributorTxnData(180));

  const columns = useMemo(
    () => [
      { key: 'txnId', label: 'Txn ID' },
      { key: 'date', label: 'Date' },
      { key: 'time', label: 'Time' },
      { key: 'masterDistributorCode', label: 'MD Code' },
      { key: 'masterDistributorName', label: 'Master Distributor Name' },
      { key: 'distributorCode', label: 'Distributor Code' },
      { key: 'distributorName', label: 'Distributor Name' },
      { key: 'service', label: 'Service' },
      {
        key: 'amount',
        label: 'Amount (₹)',
        render: (_, value) => formatCurrency(value)
      },
      {
        key: 'charge',
        label: 'Charge (₹)',
        render: (_, value) => formatCurrency(value)
      },
      {
        key: 'commission',
        label: 'Commission (₹)',
        render: (_, value) => formatCurrency(value)
      },
      {
        key: 'status',
        label: 'Status',
        render: (row) => {
          const variant =
            row.status === 'Successful'
              ? 'success'
              : row.status === 'Pending'
              ? 'warning'
              : row.status === 'Failed'
              ? 'danger'
              : 'secondary';

          return <span className={`badge bg-${variant}`}>{row.status}</span>;
        }
      },
      { key: 'rrn', label: 'RRN' },
      { key: 'referenceId', label: 'Reference ID' }
    ],
    []
  );

  return (
    <Container fluid>
      <ReportsTable
        data={transactions}
        reportType="SuperDistributor_DistributorTransactions"
        columns={columns}
        title="Distributor Transaction Report"
        cellPaddingY={8}
      />
    </Container>
  );
};

export default ReportsDistributorTransactions;


